import React, { useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import DummyImg3 from "../../assets/images/i222.webp";
import DummyImg2 from "../../assets/images/i333.webp";
import DummyImg1 from "../../assets/images/i111.webp";
import Quote from "../../assets/images/quote-up.svg";
import RightArrow from "../../assets/images/arrow-right.svg";
import LeftArrow from "../../assets/images/arrow-left.svg";
import "./reviewSection.scss";

const ReviewSection = () => {
    const carousel = useRef(null);


    return (
        <div className='review-sec-container'>
            <div className='review-sec-holder'>
                <div className="slider-btn btn-prev" onClick={() => carousel.current.slidePrev()}><img src={LeftArrow} alt="Previous" /></div>
                <AliceCarousel
                    mouseTracking
                    disableButtonsControls
                    ref={carousel}
                >
                    <div className='review-card' key="1">
                        <div className='review-details'>
                            <p className='dancing-text'>I loved it</p>
                            <img src={Quote} alt='quote-img' className='quote' />
                            <p className='review-description'>No visit to Egypt is complete without seeing the Pyramids of Giza, one of the Seven Wonders of the Ancient World. These iconic pyramids are the tomb of ancient pharaohs and the Sphinx is a mysterious limestone monument with the body of a lion and the head of a human.
                            </p>
                            <p className='reviewer-name'>Sara Dodi</p>
                        </div>
                        <img src={DummyImg2} alt='review-img' className='review-img' />
                    </div>
                    <div className='review-card' key="2">
                        <div className='review-details'>
                            <p className='dancing-text'>I loved it</p>
                            <img src={Quote} alt='quote-img' className='quote' />
                            <p className='review-description'>This site is famous for its underground tombs, including the well-preserved tomb of Tutankhamun. The intricate artwork and hieroglyphs inside these tombs offer a glimpse into ancient Egyptian life and beliefs
                            </p>
                            <p className='reviewer-name'>Jone Doe </p>
                        </div>
                        <img src={DummyImg3} alt='review-img' className='review-img' />
                    </div>
                    <div className='review-card' key="3">
                        <div className='review-details'>
                            <p className='dancing-text'>I loved it</p>
                            <img src={Quote} alt='quote-img' className='quote' />
                            <p className='review-description'>Located near Aswan, this complex of two massive rock temples is known for its colossal statues guarding the entrance and the impressive interior artwork. The temples were impressively relocated in the 1960s to prevent them from being submerged by Lake Nasser
                            </p>
                            <p className='reviewer-name'>Mai Esmail</p>
                        </div>
                        <img src={DummyImg1} alt='review-img' className='review-img' />
                    </div>
                </AliceCarousel>
                <div className="slider-btn btn-next" onClick={() => carousel.current.slideNext()}><img src={RightArrow} alt="Next" /></div>
                {/* <div className='mobile-slider-btn-holder'>
                    <div className="slider-btn btn-prev" onClick={() => carousel.current.slidePrev()}><img src={LeftArrow} alt="Previous" /></div>
                    <div className="slider-btn btn-next" onClick={() => carousel.current.slideNext()}><img src={RightArrow} alt="Next" /></div>
                </div> */}
            </div>
        </div>

    );
}

export default ReviewSection;
